/**
 * VIP Offers Resource Client
 * Axios-based API client for VIP offer endpoints
 */

import { ApiClient } from './apiClient';

export interface VipOffer {
    id: string;
    productId: string;
    variantId: string;
}

export interface VipPreviewResponse {
    savings: number;
    currency: string;
    selectedOffers: {
        productId: string;
        variantId: string;
        isSelected: boolean;
    }[];
    savingsPct: number;
}

export interface ToggleOrderBumpResponse {
    success: boolean;
    summary: any;
    availablePromotions: any[];
}

export class VipOffersResource {
    constructor(private apiClient: ApiClient) { }

    /**
     * Get VIP preview showing potential savings
     */
    async getVipPreview(
        sessionId: string,
        vipOfferIds: string[],
    ): Promise<VipPreviewResponse> {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/vip-preview`, {
            orderBumpOfferIds: vipOfferIds,
            orderBumpType: 'vip',
        });
    }

    /**
     * Toggle an order bump (used for VIP offers)
     */
    async toggleOrderBump(
        sessionId: string,
        orderBumpOfferId: string,
        selected: boolean,
    ): Promise<ToggleOrderBumpResponse> {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/toggle-order-bump`, {
            orderBumpOfferId,
            selected,
        });
    }
}


